// components/Register.js
import React, { useState } from 'react';
import axios from 'axios';

function Register({ onSwitchToLogin }) {
    const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    password: '',
    filiale: ''
  });

  const [message, setMessage] = useState('');

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const res = await axios.post(`${process.env.REACT_APP_DOMAINE}/api/register`, formData);
      setMessage(res.data.message);
      setFormData({
        full_name: '',
        email: '',
        password: '',
        filiale: ''
      });

      // Rediriger vers le login après 1 seconde
        setTimeout(() => {
            onSwitchToLogin(); // retour vers page de connexion
        }, 1000);

    } catch (err) {
      const error = err.response?.data?.error || "Erreur lors de l'inscription";
      setMessage("❌ " + error);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '500px' }}>
      <h2>Inscription d'une filiale</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-2">
          <label>Nom complet</label>
          <input
            type="text"
            name="full_name"
            className="form-control"
            required
            value={formData.full_name}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Mot de passe</label>
          <input
            type="password"
            name="password"
            className="form-control"
            required
            value={formData.password}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Filiale</label>
          <input
            type="text"
            name="filiale"
            className="form-control"
            required
            value={formData.filiale}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="btn btn-success">S'inscrire</button>
      </form>
    </div>
  );
}

export default Register;
